import { useQuery } from '@tanstack/react-query';

import queryKeys from '@/configs/react-query-keys';
import service from '@/services/index';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

const useTaxonomyListQuery = () => {
  const { data, isFetching } = useQuery({
    queryFn: () => service.taxonomy.fetchTaxonomyList(getCurrWorkspaceAlias()),
    queryKey: queryKeys.taxonomy.TAXONOMY_LIST,
  });

  return {
    data,
    isFetching,
  };
};

export default useTaxonomyListQuery;
